import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../auth_services/useAxiosPrivate';
import useAuth from '../../auth_services/useAuth';
// material
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
// icons-material
import Brightness6 from '@mui/icons-material/Brightness6';
import DarkMode from '@mui/icons-material/DarkMode';

import thana_logo from "../../picture/logo/thana_logo.png";

import { ThemeContext } from "../../Theme";

function ElevationScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return children
        ? React.cloneElement(children, {
            elevation: trigger ? 4 : 0,
        })
        : null;
}

ElevationScroll.propTypes = {
    children: PropTypes.element,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default function AppBarRegister(props) {
    const navigate = useNavigate();
    const { theme, toggleTheme, modeTitle } = useContext(ThemeContext);

    return (
        <>


        </>
    );
}